import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import useCapaAtras from '../../hooks/useCapaAtras';

// Hoja inferior para el móvil (< 768 px): sube desde abajo con un tirador,
// título, cuerpo con su propio scroll y, si se pasa, un pie fijo con botones.
// Se cierra tocando el fondo, con la X o con el botón atrás del móvil
// (useCapaAtras). Fondo blanco explícito: el proyecto no define todas las
// variables de color de shadcn.
//
// clave: texto único de la capa para el historial ('ficha-hoja-mas'...).
// pie: botones fijos abajo (Guardar...). Sin pie, el cuerpo lleva el margen
// de la zona segura del iPhone.
export default function HojaMovil({
  abierta,
  onCerrar,
  titulo = null,
  subtitulo = null,
  children,
  pie = null,
  clave = 'hoja-movil',
  testid,
  guia,
  alto = false,
}) {
  useCapaAtras(clave, !!abierta, onCerrar);

  // Mientras está abierta, la página de detrás no se desplaza
  useEffect(() => {
    if (!abierta || typeof document === 'undefined') return undefined;
    const anterior = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = anterior;
    };
  }, [abierta]);

  if (!abierta) return null;

  return (
    <div
      className="fixed inset-0 z-[55] bg-black/40 flex flex-col justify-end"
      onClick={onCerrar}
      data-testid={testid ? `${testid}-fondo` : undefined}
    >
      <div
        className={`bg-white rounded-t-2xl shadow-2xl flex flex-col ${alto ? 'h-[85vh]' : 'max-h-[85vh]'}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={typeof titulo === 'string' ? titulo : undefined}
        data-testid={testid}
        data-guia={guia}
      >
        <div className="pt-2 pb-1 shrink-0">
          <div className="mx-auto h-1 w-10 rounded-full bg-gray-300" />
        </div>
        {titulo && (
          <div className="flex items-start justify-between gap-2 pl-5 pr-2 pb-2 shrink-0 border-b border-[#EEF1EF]">
            <div className="min-w-0 pt-2">
              <h2 className="text-base font-bold text-[#16221D] leading-snug break-words">{titulo}</h2>
              {subtitulo && <p className="mt-0.5 text-[13px] text-[#5B6B64] leading-snug">{subtitulo}</p>}
            </div>
            <button
              type="button"
              onClick={onCerrar}
              className="h-11 w-11 shrink-0 rounded-full flex items-center justify-center text-[#5B6B64] active:bg-gray-100"
              aria-label="Cerrar"
              data-testid={testid ? `${testid}-cerrar` : undefined}
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        )}
        <div
          className="flex-1 min-h-0 overflow-y-auto overscroll-contain"
          style={pie ? undefined : { paddingBottom: 'calc(env(safe-area-inset-bottom) + 8px)' }}
        >
          {children}
        </div>
        {pie && (
          <div
            className="shrink-0 border-t border-[#EEF1EF] bg-white px-4 pt-3"
            style={{ paddingBottom: 'calc(env(safe-area-inset-bottom) + 12px)' }}
          >
            {pie}
          </div>
        )}
      </div>
    </div>
  );
}
